import { ConditionApi } from './condition-api';

const FilterTypeInternal = {
  SUBSTRING: 'SUBSTRING',
  PREFIX: 'PREFIX',
  PATTERN: 'PATTERN'
} as const;
/**
 * Filter type of like (text pattern) conditions
 *
 * @enum {string}
 * @readonly
 * @deprecated
 */
export const FilterType = {
  ...FilterTypeInternal,
  values: [ ...Object.values(FilterTypeInternal) ]
} as const;
/** @see net/disy/cadenza/api/result/table/FilterType;java */
export type FilterType = keyof typeof FilterTypeInternal;

const CaseSensitivityInternal = {
  INSENSITIVE: 'INSENSITIVE',
  SENSITIVE: 'SENSITIVE'
} as const;
/**
 * Case sensitivity of like (text pattern) conditions
 *
 * @enum {string}
 * @readonly
 * @deprecated
 */
export const CaseSensitivity = {
  ...CaseSensitivityInternal,
  values: [ ...Object.values(CaseSensitivityInternal) ]
} as const;
/** @see net/disy/cadenza/selection/api/condition/CaseSensitivity.java */
export type CaseSensitivity = keyof typeof CaseSensitivityInternal;

const CombinationTypeInternal = {
  OR: 'OR',
  AND: 'AND',
  NOR: 'NOR',
  NAND: 'NAND'
};
/**
 * Combination types for like (text pattern) conditions
 *
 * @enum {string}
 * @readonly
 * @deprecated
 */
export const CombinationType = {
  ...CombinationTypeInternal,
  values: [ ...Object.values(CombinationTypeInternal) ]
} as const;
/** @see net/disy/cadenza/selection/api/condition/CombinationType.java */
export type CombinationType = keyof typeof CombinationTypeInternal;

export class LikeConditionApi extends ConditionApi {

  // @ts-ignore -- the whole `setValue` interaction is unfortunate, but the way the API is used, this works.
  setValue (filterType: FilterType, caseSensitivity: CaseSensitivity, combinationType: CombinationType, likeExpressions: unknown[]) {
    const rows = likeExpressions.map(row => [ row ]);
    return super.setValue(rows, {
      filterType,
      caseSensitivity,
      combinationType
    });
  }

}
